import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import ReactPlayer from "react-player";
import "./style.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BlogMediaSwiper = ({ blogItem }) => {

  return (
    <div className="max-w-xl mx-auto border border-gray-300 rounded-lg shadow-lg overflow-hidden">
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        navigation={true}
        pagination={{ clickable: true }}
        spaceBetween={0} 
        slidesPerView={1}
        loop={false} 
        className="blog-media-swiper" 
      >
        {blogItem.blogImage && (
          <SwiperSlide>
            <img
              alt="blog banner"
              src={blogItem.blogImage}
              className="w-full object-cover" 
            />
          </SwiperSlide>
        )}
        {blogItem.blogVideo && (
          <SwiperSlide className="bg-black">
            <ReactPlayer
              src={blogItem.blogVideo} 
              controls
              width="100%"
              height="300px" 
              style={{ margin: '0 auto' }}
            />
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );
};

export default BlogMediaSwiper;